import { isLightningBinaryRendererEnabled } from "@/feature-flags";
import { getLightningRenderMode } from "@/layers/geojson/custom/utils";
import type { LightningLayer, MapProjection } from "@mm/metx-workbench.meteomatics.com";
import { ProjectionNameEnum } from "@mm/metx-workbench.meteomatics.com";

/** Binary rollout currently owns Mercator's unclustered symbol mode only. */
export function shouldUseLightningBinaryRenderer(
  layer: LightningLayer,
  projectionName: MapProjection["name"] | undefined,
  enabled = isLightningBinaryRendererEnabled(),
): boolean {
  return enabled && projectionName === ProjectionNameEnum.mercator && getLightningRenderMode(layer) === "none";
}
